import { api } from "./api";

// -------- Public --------
export const scGetOverview = async () =>
    (await api.get("/sifcontrol/public/overview")).data;
export const scListSifs = async (params = {}) =>
    (await api.get("/sifcontrol/public/sifs", { params })).data;
export const scGetSif = async (id) =>
    (await api.get(`/sifcontrol/public/sifs/${encodeURIComponent(id)}`)).data;
export const scGetSifDetail = async (id) =>
    (await api.get(`/sifcontrol/public/sifs/${encodeURIComponent(id)}/detail`)).data;
export const scGetNavHistory = async (id, window = "si") =>
    (await api.get(`/sifcontrol/public/sifs/${encodeURIComponent(id)}/nav-history`, { params: { window } })).data;
export const scFactsheetUrl = (id) => {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}/api/sifcontrol/public/sifs/${encodeURIComponent(id)}/factsheet.pdf`;
};
export const scScreener = async (params = {}) =>
    (await api.get("/sifcontrol/public/screener", { params })).data;
export const scCompare = async (ids) =>
    (await api.get("/sifcontrol/public/compare", { params: { ids: ids.join(",") } })).data;
export const scListAmcs = async () =>
    (await api.get("/sifcontrol/public/amcs")).data;
export const scGetAmc = async (id) =>
    (await api.get(`/sifcontrol/public/amcs/${encodeURIComponent(id)}`)).data;

// -------- AMC portal --------
export const scAmcLogin = async (email, password) =>
    (await api.post("/sifcontrol/amc/auth/login", { email, password })).data;
export const scAmcLogout = async () =>
    (await api.post("/sifcontrol/amc/auth/logout")).data;
export const scAmcMe = async () =>
    (await api.get("/sifcontrol/amc/me")).data;
export const scAmcDashboard = async () =>
    (await api.get("/sifcontrol/amc/dashboard")).data;
export const scAmcMySifs = async () =>
    (await api.get("/sifcontrol/amc/sifs")).data;
export const scAmcTemplateUrl = (kind = "sif_meta") => {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}/api/sifcontrol/amc/csv-template/${encodeURIComponent(kind)}`;
};
export const scAmcUploadInit = async (body) =>
    (await api.post("/sifcontrol/amc/uploads/init", body)).data;
export const scAmcUploadChunk = async (id, chunk_index, chunk_b64) =>
    (await api.post(`/sifcontrol/amc/uploads/${encodeURIComponent(id)}/chunk`, { chunk_index, chunk_b64 })).data;
export const scAmcUploadValidate = async (id) =>
    (await api.post(`/sifcontrol/amc/uploads/${encodeURIComponent(id)}/validate`)).data;
export const scAmcUploadSubmit = async (id) =>
    (await api.post(`/sifcontrol/amc/uploads/${encodeURIComponent(id)}/submit`)).data;
export const scAmcUploadList = async () =>
    (await api.get("/sifcontrol/amc/uploads")).data;
export const scAmcUploadDetail = async (id) =>
    (await api.get(`/sifcontrol/amc/uploads/${encodeURIComponent(id)}`)).data;

// -------- Admin: AMC upload review + bulk seed --------
export const scAdminAmcUploads = async (params = {}) =>
    (await api.get("/sifcontrol/admin/amc-uploads", { params })).data;
export const scAdminAmcUploadDetail = async (id) =>
    (await api.get(`/sifcontrol/admin/amc-uploads/${encodeURIComponent(id)}`)).data;
export const scAdminApproveUpload = async (id, note = "") =>
    (await api.post(`/sifcontrol/admin/amc-uploads/${encodeURIComponent(id)}/approve`, { note })).data;
export const scAdminRejectUpload = async (id, note = "") =>
    (await api.post(`/sifcontrol/admin/amc-uploads/${encodeURIComponent(id)}/reject`, { note })).data;
export const scAdminAmcUploadFields = async () =>
    (await api.get("/sifcontrol/admin/amc-upload-fields")).data;
export const scAdminGetBatch = async (id) =>
    (await api.get(`/sifcontrol/admin/batches/${encodeURIComponent(id)}`)).data;
export const scAdminPromoteUnmapped = async (batch_id, amc_id) =>
    (await api.post(`/sifcontrol/admin/batches/${encodeURIComponent(batch_id)}/promote-unmapped`, { amc_id: amc_id || null })).data;

export const scAdminUploadDataFile = async (data_type, file) => {
    const form = new FormData();
    form.append("file", file);
    return (await api.post(`/sifcontrol/admin/uploads/${encodeURIComponent(data_type)}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    })).data;
};

export const scAdminRerunBatch = async (batch_id) =>
    (await api.post(`/sifcontrol/admin/batches/${encodeURIComponent(batch_id)}/rerun`)).data;

export const scAdminSchedulerStatus = async () =>
    (await api.get("/sifcontrol/admin/scheduler/status")).data;

export const scAdminSchedulerReload = async () =>
    (await api.post("/sifcontrol/admin/scheduler/reload")).data;

// -------- Admin (uses existing OTH admin auth cookie) --------
export const scAdminSettings = async () =>
    (await api.get("/sifcontrol/admin/settings")).data;
export const scAdminSaveSettings = async (patch) =>
    (await api.patch("/sifcontrol/admin/settings", patch)).data;
export const scAdminOverview = async () =>
    (await api.get("/sifcontrol/admin/overview")).data;

// AMCs
export const scAdminListAmcs = async () =>
    (await api.get("/sifcontrol/admin/amcs")).data;
export const scAdminCreateAmc = async (body) =>
    (await api.post("/sifcontrol/admin/amcs", body)).data;
export const scAdminPatchAmc = async (id, patch) =>
    (await api.patch(`/sifcontrol/admin/amcs/${encodeURIComponent(id)}`, patch)).data;
export const scAdminDeleteAmc = async (id) =>
    (await api.delete(`/sifcontrol/admin/amcs/${encodeURIComponent(id)}`)).data;

// SIFs
export const scAdminListSifs = async (params = {}) =>
    (await api.get("/sifcontrol/admin/sifs", { params })).data;
export const scAdminCreateSif = async (body) =>
    (await api.post("/sifcontrol/admin/sifs", body)).data;
export const scAdminPatchSif = async (id, patch) =>
    (await api.patch(`/sifcontrol/admin/sifs/${encodeURIComponent(id)}`, patch)).data;
export const scAdminDeleteSif = async (id) =>
    (await api.delete(`/sifcontrol/admin/sifs/${encodeURIComponent(id)}`)).data;

// AMC users
export const scAdminListAmcUsers = async () =>
    (await api.get("/sifcontrol/admin/amc-users")).data;
export const scAdminCreateAmcUser = async (body) =>
    (await api.post("/sifcontrol/admin/amc-users", body)).data;
export const scAdminPatchAmcUser = async (id, patch) =>
    (await api.patch(`/sifcontrol/admin/amc-users/${encodeURIComponent(id)}`, patch)).data;
export const scAdminDeleteAmcUser = async (id) =>
    (await api.delete(`/sifcontrol/admin/amc-users/${encodeURIComponent(id)}`)).data;

// Data jobs
export const scAdminRunJob = async (type) =>
    (await api.post(`/sifcontrol/admin/jobs/${encodeURIComponent(type)}/run`)).data;
export const scAdminListBatches = async (params = {}) =>
    (await api.get("/sifcontrol/admin/batches", { params })).data;
export const scAdminLatestBatches = async () =>
    (await api.get("/sifcontrol/admin/batches/latest")).data;

// Analytics + Rankings
export const scAdminRecomputeAnalytics = async () =>
    (await api.post("/sifcontrol/admin/analytics/recompute")).data;
export const scAdminMetricsCatalog = async () =>
    (await api.get("/sifcontrol/admin/analytics/metrics-catalog")).data;
export const scAdminListRankings = async () =>
    (await api.get("/sifcontrol/admin/rankings")).data;
export const scAdminGetRanking = async (id) =>
    (await api.get(`/sifcontrol/admin/rankings/${encodeURIComponent(id)}`)).data;
export const scAdminCreateRanking = async (body) =>
    (await api.post("/sifcontrol/admin/rankings", body)).data;
export const scAdminPatchRanking = async (id, patch) =>
    (await api.patch(`/sifcontrol/admin/rankings/${encodeURIComponent(id)}`, patch)).data;
export const scAdminDeleteRanking = async (id) =>
    (await api.delete(`/sifcontrol/admin/rankings/${encodeURIComponent(id)}`)).data;
export const scAdminComputeRanking = async (id) =>
    (await api.post(`/sifcontrol/admin/rankings/${encodeURIComponent(id)}/compute`)).data;
export const scAdminRankingResults = async (id) =>
    (await api.get(`/sifcontrol/admin/rankings/${encodeURIComponent(id)}/results`)).data;

// -------- Admin: NAV History fetch (AMFI) --------
export const scAdminNavHistFetch = async ({ date, start_date, end_date }) =>
    (await api.post("/sifcontrol/admin/nav-history/fetch",
        date ? { date } : { start_date, end_date })).data;
export const scAdminNavHistList = async () =>
    (await api.get("/sifcontrol/admin/nav-history/stages")).data;
export const scAdminNavHistGet = async (id) =>
    (await api.get(`/sifcontrol/admin/nav-history/stages/${encodeURIComponent(id)}`)).data;
export const scAdminNavHistRefresh = async (id) =>
    (await api.post(`/sifcontrol/admin/nav-history/stages/${encodeURIComponent(id)}/refresh`)).data;
export const scAdminNavHistImport = async (id) =>
    (await api.post(`/sifcontrol/admin/nav-history/stages/${encodeURIComponent(id)}/import`)).data;
export const scAdminNavHistDelete = async (id) =>
    (await api.delete(`/sifcontrol/admin/nav-history/stages/${encodeURIComponent(id)}`)).data;
export const scAdminNavHistDownloadUrl = (id) => {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}/api/sifcontrol/admin/nav-history/stages/${encodeURIComponent(id)}/download`;
};
export const scAdminNavHistListMap = async () =>
    (await api.get("/sifcontrol/admin/nav-history/name-map")).data;
export const scAdminNavHistSaveMap = async (amfi_scheme_name, sif_code) =>
    (await api.post("/sifcontrol/admin/nav-history/name-map", { amfi_scheme_name, sif_code })).data;
export const scAdminNavHistDeleteMap = async (norm) =>
    (await api.delete(`/sifcontrol/admin/nav-history/name-map/${encodeURIComponent(norm)}`)).data;
export const scAdminNavHistUpload = async (file) => {
    const form = new FormData();
    form.append("file", file);
    return (await api.post("/sifcontrol/admin/nav-history/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
    })).data;
};

// Public rankings
export const scListRankings = async () =>
    (await api.get("/sifcontrol/public/rankings")).data;
export const scGetRankingResults = async (id) =>
    (await api.get(`/sifcontrol/public/rankings/${encodeURIComponent(id)}/results`)).data;
